<template>
  <header class="main-header elr-container">
    <div class="elr-row">
      <div class="elr-col-full main-header-inner">
        <Logo />
        <div class="site-nav-holder">
          <NavigationMain
            :user="user"
            @loggedOut="logout"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from '../Logo/Logo';
import NavigationMain from '../NavigationMain/NavigationMain';

export default {
  name: 'MainHeader',
  components: {
    Logo,
    NavigationMain
  },
  props: {
    user: {
      type: Object
    }
  },
  methods: {
    logout() {
      this.$emit('loggedOut');
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.main-header-inner {
  // @include elr-clearfix;
  padding: 20px 0 10px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1250px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    text-align: center;
  }

  > div {
    flex-grow: 1;
    flex-shrink: 1;
  }

  a {
    text-decoration: none;
  }
}
</style>

<style lang="scss">
.main-header-inner {
  .main-nav {
    float: right;

    @media (max-width: 1000px) {
      float: none;
    }
  }

  .main-menu {
    margin: 0;
    text-align: right;

    @media (max-width: 1000px) {
      text-align: center;
    }
  }
}
</style>

